module.exports = __webpack_public_path__ + "0593b4ff950c011583061f237f25e293.svg";